import { Select, Row, Col, Modal, Button, Table, InputNumber, Tag, FloatButton, message, Empty, Input, Skeleton, Dropdown } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Search from '..'
import moment from 'moment'
import { ReloadOutlined, CaretUpOutlined, PlusOutlined, EyeOutlined, SearchOutlined, RedoOutlined, ExperimentOutlined, ThunderboltOutlined, ClockCircleOutlined } from '@ant-design/icons';
import API_ROUTES from '../../../api'
import axios from 'axios'
import './index.css'
import AuditPendingNotice from '../../../components/AuditPendingNotice'
import { refreshCurrentProfile } from '../../../utils/authProfile'
import GsrdWch from '../../../components/GsrdWch'

export default function SearchInput() {

    const navigate = useNavigate()
    const [messageApi, contextHolder] = message.useMessage();

    const [modelOpen, setModelOpen] = useState(false)
    const [tableLoading, setTableLoading] = useState(false)
    const [tableInfo, setTableInfo] = useState([])

    const [modelChrInfo, setModelChrInfo] = useState(13)
    const [modelPosInfo, setModelPosInfo] = useState(20189473)
    const [modelRefInfo, setModelRefInfo] = useState('C')
    const [modelAltInfo, setModelAltInfo] = useState('T')
    const [currentPage, setCurrentPage] = useState(1)
    const [pageTotalCount, setPageTotalCount] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    // 使用useRef创建一个引用，指向目标元素
    const targetRef = useRef(null);
    const [resResult, setResResult] = useState()
    const [detailEmpty, setDetailEmpty] = useState(false)
    let intervalId = useRef(null);
    const [detailLoading, setDetailLoading] = useState(false)
    const [retryLoadingId, setRetryLoadingId] = useState()
    // 查询列表自动刷新间隔，默认30秒，用户可在页面按钮中切换
    const [refreshInterval, setRefreshInterval] = useState(30 * 1000)
    const [profileLoading, setProfileLoading] = useState(true)
    const [profileStatus, setProfileStatus] = useState(localStorage.getItem('status'))
    const userInfo = localStorage.getItem('userInfo');
    const isAuditPending = userInfo && ['0', '2'].includes(String(profileStatus ?? ''));

    const refreshIntervalOptions = [
        { key: '5000', label: 'Every 5 seconds' },
        { key: '10000', label: 'Every 10 seconds' },
        { key: '30000', label: 'Every 30 seconds' },
        { key: '60000', label: 'Every 60 seconds' },
    ]

    // 点击按钮时触发滚动事件
    const scrollToTarget = () => {
        if (targetRef.current) {
            targetRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };


    useEffect(() => {
        if (!userInfo) {
            // 直接访问 Variant Search 时记录目标页，登录后回到查询页面
            navigate('/login', { state: { from: '/searchInput' } })
            return;
        }
        let cancelled = false;
        setProfileLoading(true);
        refreshCurrentProfile()
            .then((profile) => {
                if (cancelled) {
                    return;
                }
                setProfileStatus(profile.status);
                if (['0', '2'].includes(String(profile.status))) {
                    return;
                }
                getListInfo(currentPage, pageSize);
                // 根据用户选择的刷新频率重建查询列表轮询，避免多个定时器叠加
                intervalId.current = setInterval(() => getListInfo(currentPage, pageSize), refreshInterval);
            })
            .catch(() => {
                if (!cancelled) {
                    navigate('/login', { state: { from: '/searchInput' } });
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setProfileLoading(false);
                }
            });
        return () => {
            cancelled = true;
            if (intervalId.current) {
                clearInterval(intervalId.current);
                intervalId.current = null;
            }
        };
    }, [currentPage, pageSize, refreshInterval, navigate, userInfo]); // 页码、分页大小或刷新频率变化时重新设置定时器


    const getListInfo = (page = currentPage, size = pageSize) => {
        setTableLoading(true)
        axios.post(API_ROUTES.api_search_searchList, {
            sendTimeOrder: "DESC",
            current: page,
            size
        }, {
            headers: {
                Authorization: localStorage.getItem('userInfo')
            }
        })
            .then(function (response) {
                if (response.data.code === 500) {
                    Modal.error({
                        content: response.data.msg
                    });
                } else {
                    setTableInfo(response.data.data)
                    setPageTotalCount(response.data.data.total)
                }
            })
            .catch(function (error) {
            })
            .finally(() => {
                setTableLoading(false)
            });
    }


    const pageSizeChange = (_, currentPage) => {
        setPageSize(currentPage)
    }

    const statusFunc = (value) => {
        switch (value) {
            case 0:
                return (
                    <Tag color="gray" style={{ fontSize: '14px' }}>
                        waiting
                    </Tag>
                )
            case 1:
                return (
                    <Tag color="blue" style={{ fontSize: '14px' }}>
                        processing
                    </Tag>
                )
            case 2:
                return <Tag color="green" style={{ fontSize: '14px' }}>Completed</Tag>
            default:
                return <Tag color="red" style={{ fontSize: '14px' }}>error</Tag>
        }
    }

    // 将异常任务重置为等待状态，由后端MissionTask重新扫描执行
    const retrySearch = (record) => {
        Modal.confirm({
            title: 'Retry this query?',
            content: 'The failed query will be reset and submitted again by the task scheduler.',
            okText: 'Retry',
            onOk: async () => {
                setRetryLoadingId(record.id)
                const formData = new FormData();
                formData.append('id', record.id);
                try {
                    const response = await axios.post(API_ROUTES.api_search_retry, formData, {
                        headers: {
                            Authorization: localStorage.getItem('userInfo')
                        }
                    });
                    if (response.data.code === 500) {
                        messageApi.error(response.data.msg || 'Retry failed');
                        return;
                    }
                    messageApi.success('The query has been queued again');
                    getListInfo(currentPage, pageSize);
                } catch (error) {
                    messageApi.error('Retry failed');
                } finally {
                    setRetryLoadingId(undefined)
                }
            }
        });
    }


    const chrOptions = Array.from({ length: 22 }, (_, i) => ({ value: (i + 1).toString(), label: (i + 1).toString() }))
        .concat({ value: 'X', label: 'X' })
        .concat({ value: 'Y', label: 'Y' });

    // 未登录时先阻止页面内容挂载，避免继续触发需要 token 的查询接口
    if (!userInfo) {
        return null;
    }

    if (profileLoading) {
        return (
            <div className="search-page">
                <Skeleton active paragraph={{ rows: 8 }} />
            </div>
        );
    }

    if (isAuditPending) {
        return <AuditPendingNotice />;
    }

    return (
        <div className="search-page">
            <Row style={{ width: '100%' }} justify="center">
                <Col xs={24} sm={20}>

                    {contextHolder}
                    {/* 查询任务区域：突出主操作，并为任务列表提供清晰的视觉层级 */}
                    <section className="search-task-panel">
                        <div className="search-task-heading">
                            <div>
                                <h1>Variant search</h1>
                            </div>
                            <div className="search-task-actions">
                                <Button
                                    className="search-reload-button"
                                    icon={<ReloadOutlined />}
                                    onClick={() => getListInfo(currentPage, pageSize)}
                                >
                                    Refresh
                                </Button>
                                <Dropdown
                                    trigger={['click']}
                                    menu={{
                                        items: refreshIntervalOptions,
                                        selectable: true,
                                        selectedKeys: [String(refreshInterval)],
                                        onClick: ({ key }) => setRefreshInterval(Number(key))
                                    }}
                                >
                                    <Button
                                        className="search-refresh-interval-button"
                                        icon={<ClockCircleOutlined />}
                                    >
                                        Auto-refresh every {refreshInterval / 1000}s
                                    </Button>
                                </Dropdown>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setModelOpen(true)}
                                >
                                    New variant search
                                </Button>
                            </div>
                        </div>

                        <div className="search-table-shell">
                            <Table
                        columns={[
                            {
                                title: (
                                    <div className="search-table-title">
                                        Variant
                                    </div>
                                ),
                                dataIndex: 'searchChr',
                                key: 'searchChr',
                                render: (_, record) => (
                                    <div className="variant-value">
                                        <span className="variant-icon"><SearchOutlined /></span>
                                        <span>{'chr' + record.searchChr + ':' + record.searchPos + '-' + record.searchRef + '-' + record.searchAlt}</span>
                                    </div>
                                )
                                ,
                                width: 80,
                                ellipsis: true,
                            },
                            {
                                title: (
                                    <div className="search-table-title">
                                        Status
                                    </div>
                                ),
                                dataIndex: 'status',
                                key: 'status',
                                render: (_, record) => (
                                    statusFunc(record.status)
                                ),
                                width: 80,
                                ellipsis: true,
                            },
                            {
                                title: (
                                    <div className="search-table-title">
                                        Search date
                                    </div>
                                ),
                                dataIndex: 'searchTime',
                                key: 'SearchTime',
                                render: (text) =>
                                    <div style={{ fontSize: '16px' }}>
                                        {moment(text).format('YYYY-MM-DD HH:mm:ss')}
                                    </div>,
                                width: 80,
                                ellipsis: true,
                            },
                            {
                                title: (
                                    <div className="search-table-title">
                                        Details
                                    </div>
                                ),
                                dataIndex: 'others',
                                key: 'others',
                                fixed: 'right',
                                width: 130,
                                render: (_, record) => {
                                    return (
                                        <div className="search-row-actions">
                                            {record.status === 2 &&
                                                <Button
                                                    size='small'
                                                    type='primary'
                                                    className="show-detail-button"
                                                    icon={<EyeOutlined />}
                                                    onClick={async () => {
                                                        setDetailLoading(true)
                                                        setDetailEmpty(false)
                                                        const formData = new FormData();
                                                        formData.append('id', record.id);
                                                        await axios.post(API_ROUTES.api_search_parseResult, formData, {
                                                            headers: {
                                                                Authorization: localStorage.getItem('userInfo')
                                                            }
                                                        })
                                                            .then(function (response) {
                                                                if (response.data.code === 500) {
                                                                    Modal.error({
                                                                        content: response.data.msg
                                                                    });
                                                                } else {
                                                                    // 接口返回空对象或缺少核心检索信息时，展示独立的无结果提示
                                                                    const detailData = response.data.data;
                                                                    const hasDetail = detailData
                                                                        && typeof detailData === 'object'
                                                                        && Object.keys(detailData).length > 0
                                                                        && detailData.searchInfo;
                                                                    setResResult(hasDetail ? detailData : undefined)
                                                                    setDetailEmpty(!hasDetail)
                                                                }
                                                            })
                                                            .catch(function (error) {
                                                                Modal.error({
                                                                    content: 'error'
                                                                });
                                                            })
                                                            .finally(() => {
                                                                setDetailLoading(false)
                                                                scrollToTarget()
                                                            });
                                                    }}
                                                >
                                                    View details
                                                </Button>

                                            }
                                            {record.status === 3 &&
                                                <Button
                                                    size='small'
                                                    className="retry-query-button"
                                                    icon={<RedoOutlined />}
                                                    loading={retryLoadingId === record.id}
                                                    onClick={() => retrySearch(record)}
                                                >
                                                    Retry
                                                </Button>
                                            }
                                        </div>
                                    );
                                },

                                ellipsis: true,
                            },
                        ]}
                        loading={tableLoading}
                        dataSource={tableInfo.records}
                        rowKey="id"
                        scroll={{
                            x: '1500px',
                            y: '500px'
                        }}
                        size='small'
                        tableLayout='fixed'
                        pagination={{
                            showQuickJumper: true,
                            defaultPageSize: 10,
                            defaultCurrent: 1,
                            current: currentPage,
                            total: pageTotalCount,
                            onChange: (pageNum) => {
                                setCurrentPage(pageNum)
                                getListInfo(pageNum, pageSize)
                            },
                            pageSize: pageSize,
                            onShowSizeChange: pageSizeChange
                        }}
                        bordered
                            />
                        </div>
                    </section>
                </Col>
                <Modal
                    className="search-create-modal"
                    title={
                        <div className="search-modal-title">
                            <span className="search-modal-title-icon"><ExperimentOutlined /></span>
                            <div>
                                <strong>Search for <GsrdWch /></strong>
                                <span>Enter a genomic variant to create a new query task.</span>
                            </div>
                        </div>
                    }
                    centered
                    closable
                    open={modelOpen}
                    onOk={() => {
                        setModelOpen(false)
                        if (!modelChrInfo || !modelPosInfo || !modelRefInfo || !modelAltInfo) {
                            messageApi.open({
                                type: 'error',
                                content: 'The query parameter cannot be empty',
                                className: 'custom-class',
                                style: {
                                    marginTop: '40vh',
                                },
                            });
                        } else {
                            axios.post(API_ROUTES.api_search_searchOne, {
                                chr: modelChrInfo,
                                pos: modelPosInfo,
                                ref: modelRefInfo,
                                alt: modelAltInfo
                            }, {
                                headers: {
                                    Authorization: localStorage.getItem('userInfo')
                                }
                            })
                                .then(function (response) {
                                    if (response.data.code === 500) {
                                        Modal.error({
                                            content: response.data.msg
                                        });
                                    } else {
                                        Modal.success({
                                            content: "Sending search information success!"
                                        });
                                        getListInfo();
                                    }
                                })
                                .catch(function (error) {
                                    navigate('/login', { state: { from: '/searchInput' } })
                                    Modal.error({
                                        content: error.response.data.msgDes
                                    });
                                })
                        }
                    }
                    }
                    okText='Search'
                    okButtonProps={{
                        icon: <SearchOutlined />,
                        className: 'search-modal-submit'
                    }}
                    cancelButtonProps={{
                        className: 'search-modal-cancel'
                    }}
                    onCancel={() => setModelOpen(false)}
                    width={760}
                >
                    {/* 查询参数使用独立输入卡片，增强字段含义与输入层级 */}
                    <div className="search-modal-content">
                        <div className="search-modal-fields">
                            <label className="search-field-card">
                                <span className="search-field-label">Chromosome</span>
                                <span className="search-field-hint">Chr</span>
                            <Select
                                defaultValue='13'
                                onChange={(value) => setModelChrInfo(value)}
                                options={chrOptions}
                            />
                            </label>
                            <label className="search-field-card">
                                <span className="search-field-label">Position</span>
                                <span className="search-field-hint">GRCh38 coordinate</span>
                            <InputNumber
                                min={0}
                                defaultValue={20189473}
                                onChange={(value) => setModelPosInfo(value)}
                                changeOnWheel
                            />
                            </label>
                            <label className="search-field-card">
                                <span className="search-field-label">Reference allele</span>
                                <span className="search-field-hint">Ref</span>
                            <Input
                                value={modelRefInfo}
                                onChange={e => setModelRefInfo(e.target.value)}
                            />
                            </label>
                            <label className="search-field-card">
                                <span className="search-field-label">Alternate allele</span>
                                <span className="search-field-hint">Alt</span>
                            <Input
                                value={modelAltInfo}
                                onChange={e => setModelAltInfo(e.target.value)}
                            />
                            </label>
                        </div>

                        <button
                            type="button"
                            className="search-example-card"
                            onClick={() => {
                                setModelOpen(false)
                                axios.post(API_ROUTES.api_search_searchOne, {
                                    chr: 13,
                                    pos: 20189473,
                                    ref: 'C',
                                    alt: 'T'
                                }, {
                                    headers: {
                                        Authorization: localStorage.getItem('userInfo')
                                    }
                                })
                                    .then(function (response) {
                                        if (response.data.code === 500) {
                                            Modal.error({
                                                content: response.data.msg
                                            });
                                        } else {
                                            Modal.success({
                                                content: "Sending search information success!"
                                            });
                                            getListInfo();
                                        }
                                    })
                                    .catch(function (error) {
                                        navigate('/login', { state: { from: '/searchInput' } })
                                        Modal.error({
                                            content: error.response.data.msgDes
                                        });
                                    })
                            }}>
                            <span className="search-example-icon"><ThunderboltOutlined /></span>
                            <span>
                                <small>Quick example</small>
                                <strong>chr13:20189473-C-T</strong>
                            </span>
                            <span className="search-example-action">Run example</span>
                        </button>
                    </div>
                </Modal>
            </Row>


            {/* show detail请求过程中优先展示加载态，避免接口返回前仍显示空状态 */}
            {detailLoading ?
                <div ref={targetRef} className="search-detail-loading">
                    <Skeleton active paragraph={{ rows: 16 }} />
                </div> :
                detailEmpty ?
                <div ref={targetRef} className="search-empty-shell search-no-result-shell">
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <div className="search-empty-description">
                                <strong>No matching variant details found</strong>
                                <span>The query completed successfully, but no detail data is available for this variant.</span>
                            </div>
                        }
                    />
                </div> :
                !resResult ?
                <div ref={targetRef} className="search-empty-shell">
                    <Empty
                        description='Select a completed query to view its detail'
                    />
                </div> :
                    <div ref={targetRef} className="search-result-shell">
                        <Search dataInfo={resResult} />
                    </div>
            }


            <FloatButton.BackTop
                type="primary"
                shape="square"
                icon={
                    <CaretUpOutlined />
                }
                style={{ insetInlineEnd: 94 }}
                description="BACK TO TOP!"
            />

        </div>
    )
}
